export default "__VITE_ASSET__DaoIbT8___"